import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import { Button, Grid2 } from "@mui/material";
import { ColDef, EditableCallbackParams } from "ag-grid-community";
import moment from "moment";
import React from "react";
import { ShiftParameters } from "../../models/ShiftParameters";

type Props = {
	setShiftSelected: (shiftSelected: ShiftParameters | null) => void;
	setOpenModalEditShift: Function;
	setOpenModalDeleteShift: Function;
	showContextMenu: Function;
};

export const useTableData = ({
	setShiftSelected,
	setOpenModalEditShift,
	setOpenModalDeleteShift,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "PatternStart",
			headerName: "Pattern Start",
			valueFormatter: ({ value }: { value: any }) =>
				`${moment(value).format("L")}, ${moment(value).format("LTS")}`,
			minWidth: 180,
			flex: 4,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			field: "ShiftCodes",
			headerName: "Shift Codes",
			minWidth: 150,
			flex: 2,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			field: "Crews",
			headerName: "Crews",
			minWidth: 150,
			flex: 2,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			sortable: false,
			field: "PatternDays",
			headerName: "Shifts",
			minWidth: 130,
			flex: 1,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
		},
		{
			cellRenderer: (params: EditableCallbackParams) => {
				return (
					<Grid2
						container
						style={{
							height: "100%",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
						sx={{
							opacity: 0,
							transition: "opacity 0.1s ease-in-out",
							".ag-row-hover &": {
								opacity: 1,
							},
							".ag-row-focus &": {
								opacity: 1,
							},
							".ag-row-selected &": {
								opacity: 1,
							},
						}}
					>
						<Grid2
							size={{ xs: 12, md: 12 }}
							style={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<Button
								style={{}}
								onClick={() => {
									setShiftSelected(params?.data as ShiftParameters);
									setOpenModalEditShift(true);
								}}
							>
								<EditIcon color="primary" />
							</Button>
							<Button
								style={{}}
								onClick={() => {
									setShiftSelected(params?.data as ShiftParameters);
									setOpenModalDeleteShift(true);
								}}
							>
								<DeleteIcon color="secondary" />
							</Button>
							<Button
								style={{}}
								onClick={(e) => showContextMenu(e, params.data, "TableShifts")}
							>
								<FormatListBulletedSharpIcon color="action" />
							</Button>
						</Grid2>
					</Grid2>
				);
			},
			field: "",
			flex: 3,
			minWidth: 240,
			editable: false,
			autoHeight: false,
			suppressNavigable: true,
		},
	];

	return { columnDefs };
};
